import updateSingleItemQuantity from './update-single-item-quantity';
import updateSingleItemDepot from './update-single-item-depot';
import decorateSelectionItem from './decorate-selection-item';

export default {
	updateSingleItemQuantity,
	updateSingleItemDepot,
	decorateSelectionItem
};
